import { SeatMapRestrictions } from '@websky/graphql';
import { SeatMapRowSeat } from '../model/types';

export function getIsSeatAvailableByFilters(filters: SeatMapRestrictions[]) {
	return (seat: SeatMapRowSeat): SeatMapRowSeat => {
		if (!seat.restrictions?.length || !filters.length) {
			return seat;
		}

		const isIncludeFilter = !seat.restrictions.some(restriction => filters.includes(restriction));

		return {
			...seat,
			isAvailable: seat.isAvailable && isIncludeFilter
		};
	};
}
